import { ref, watch } from "vue";

import useBonusomatData from "./use-bonusomat-data";
import { useNgSession } from "@sazka/ng/ng-session";

const { isLoggedIn } = useNgSession();

const { allwynDrawData, loadAllwynDrawData } = useBonusomatData();

const allwynDrawRemainingSeconds = ref(0);
let intervalAllwynDrawRemainingHandle = 0;
async function intervalAllwynDrawRemainingHandler() {
    if (allwynDrawRemainingSeconds.value > 0) {
        allwynDrawRemainingSeconds.value--;
    } else {
        if (allwynDrawData.value) {
            allwynDrawData.value.drawRemainingSeconds = 0;
        }

        if (intervalAllwynDrawRemainingHandle) {
            clearInterval(intervalAllwynDrawRemainingHandle);
        }

        await loadAllwynDrawData();
    }
}

async function initDrawRemainingInterval() {
    if (intervalAllwynDrawRemainingHandle) {
        clearInterval(intervalAllwynDrawRemainingHandle);
    }

    intervalAllwynDrawRemainingHandle = window.setInterval(() => intervalAllwynDrawRemainingHandler(), 1000);
}

function initCountdowns(newAllwynDrawRemainingSeconds: number) {
    allwynDrawRemainingSeconds.value = newAllwynDrawRemainingSeconds;

    initDrawRemainingInterval();
}

watch(
    () => allwynDrawData.value?.drawRemainingSeconds,
    (newAllwynDrawRemainingSeconds) => {
        if (newAllwynDrawRemainingSeconds) {
            initCountdowns(newAllwynDrawRemainingSeconds);
        } else {
            clearInterval(intervalAllwynDrawRemainingHandle);
        }
    },
    { immediate: true }
);

watch(isLoggedIn, (newVal) => {
    if (!newVal) {
        clearInterval(intervalAllwynDrawRemainingHandle);
    }
});

export default function useBonusomatAllwynDrawCountdown() {
    return {
        allwynDrawRemainingSeconds,
    };
}
